import type {
  ApplicationFileAttachment,
  OtherSource,
  ResidentApplicationData,
} from '@/types/application'

/** Other income sources — API may use resident_other_source or other_source */
export function getResidentOtherSources(
  data: ResidentApplicationData | null | undefined
): OtherSource[] {
  if (!data) return []
  return data.resident_other_source ?? data.other_source ?? []
}

/**
 * GET other-income rows omit `present_job`. A missing flag is not the same as
 * "not active": a null/empty end date is the stored "currently active" signal.
 * Save validation defaults a missing `present_job` to inactive and then
 * requires an end date, so re-posting the raw row rejects a second active source.
 */
export function ensureOtherSourcePresentJob(source: OtherSource): OtherSource {
  if (source.present_job === "1" || source.present_job === "0") return source
  const end = source.job_end_date
  const hasEndDate =
    end != null &&
    String(end).trim() !== "" &&
    String(end).trim().toLowerCase() !== "null"
  return { ...source, present_job: hasEndDate ? "0" : "1" }
}

export function isBankAlreadyLinked(
  data: ResidentApplicationData | null | undefined
): boolean {
  if (!data?.bank_already_link) return false
  const flag = data.bank_already_link
  return flag === true || flag === 1 || flag === '1'
}

/** Normalize government ID attachment field (object or array) to array */
export function normalizeGovIdAttachments(
  attachment:
    | ApplicationFileAttachment
    | ApplicationFileAttachment[]
    | null
    | undefined
): ApplicationFileAttachment[] {
  if (!attachment) return []
  return Array.isArray(attachment)
    ? attachment
    : attachment.attachment_id
      ? [attachment]
      : []
}

export function getAttachmentFileName(file: ApplicationFileAttachment): string {
  return file.filename || file.name || 'file'
}
